// Jedzenie (/posilki…): Dziś, Tydzień, Katalog, Produkty, Ustawienia, arkusze i dialogi.
export default {
    common: {
        add: 'Dodaj',
        adding: 'Dodaję…',
        save: 'Zapisz',
        saving: 'Zapisuję…',
        delete: 'Usuń',
        edit: 'Edytuj',
        cancel: 'Anuluj',
        close: 'Zamknij',
        back: 'Wstecz',
        less: 'Mniej',
        more: 'Więcej',
        up: 'Wyżej',
        down: 'Niżej',
        loading: 'Ładuję…',
        portions: 'Porcje',
        fewerServings: 'Mniej porcji',
        moreServings: 'Więcej porcji',
        servingsN: '{n} porcji',
        ingredientsHeading: 'SKŁADNIKI',
        aiUnavailable: 'AI jest teraz niedostępne.',
    },
    errors: {
        save: 'Nie udało się zapisać.',
        add: 'Nie udało się dodać.',
        addProduct: 'Nie udało się dodać produktu.',
        saveMeal: 'Nie udało się zapisać posiłku.',
        delete: 'Nie udało się usunąć.',
        generic: 'Nie udało się.',
    },
    ingredient: 'Składnik',
    days: {
        today: 'Dziś',
        tomorrow: 'Jutro',
        yesterday: 'Wczoraj',
    },
    units: {
        label: {
            szt: 'szt.',
            lyzka: 'łyżka',
            lyzeczka: 'łyżeczka',
            szklanka: 'szklanka',
            porcja: 'porcja',
        },
        amount: {
            lyzka: '{n} łyżka | {n} łyżki | {n} łyżek',
            lyzeczka: '{n} łyżeczka | {n} łyżeczki | {n} łyżeczek',
            szklanka: '{n} szklanka | {n} szklanki | {n} szklanek',
            porcja: '{n} porcja | {n} porcje | {n} porcji',
        },
    },
    nutrients: {
        label: {
            calories: 'Kalorie',
            protein: 'Białko',
            carbs: 'Węglowodany',
            fat: 'Tłuszcz',
            fiber: 'Błonnik',
            sugar: 'Cukier',
            saturated_fat: 'Tłuszcze nasycone',
            salt: 'Sól',
        },
        short: {
            protein: 'B',
            carbs: 'W',
            fat: 'T',
            fiber: 'błonnik',
            sugar: 'cukier',
            saturated_fat: 'nasycone',
            salt: 'sól',
        },
        macros: 'B {protein} · W {carbs} · T {fat}',
    },
    goalKinds: {
        target: { label: 'cel', hint: 'trafić w okolice' },
        min: { label: 'co najmniej', hint: 'mniej to za mało' },
        max: { label: 'najwyżej', hint: 'więcej to za dużo' },
    },
    portions: {
        half: '½ porcji',
        count: '{n} porcja | {n} porcje | {n} porcji',
        defaultName: 'porcja',
    },
    slots: {
        none: 'Bez pory',
    },
    source: {
        nutrition: {
            label: 'z etykiety',
            manual: 'poprawione',
            ai: 'szacunek AI',
        },
        price: {
            receipt: 'z paragonu',
            basket: 'z zakupów',
            label: 'z etykiety',
            manual: 'poprawiona',
            ai: 'szacunek AI',
        },
    },
    aiMacros: {
        field: {
            protein: 'B',
            carbs: 'W',
            fat: 'T',
            saturated_fat: 'nas.',
            sugar: 'cukry',
            fiber: 'błon.',
            salt: 'sól',
            category: 'kategoria',
        },
        error: {
            notFound: 'Nie ma już tego wpisu — odśwież widok.',
            rejected: 'API nie przyjęło pytania o makra.',
            noAnswer: 'AI nie odpowiedziało. Spróbuj jeszcze raz.',
            notConfigured: 'AI nie jest skonfigurowane po stronie API.',
            generic: 'Nie udało się pobrać propozycji makr.',
        },
        dialog: {
            title: 'Uzupełnij makra AI',
            subjectIngredients: 'Składniki „{name}"',
            productIngredients: 'Produkty-składniki',
            units: 'wartości na 100 g, sól w mg, cena w {currency}/kg',
            loading: 'Pytam AI o makra składników…',
            retry: 'Spróbuj ponownie',
            empty: 'AI nie zwróciło żadnej propozycji dla tego posiłku.',
            counts: 'PRODUKTY: {total} · DO ZMIANY: {changed}',
            unselectAll: 'Odznacz wszystkie',
            selectAll: 'Zaznacz wszystkie',
            noChanges: 'bez zmian',
            hint: 'Zapis idzie w produkty katalogu — makra posiłków, które ich używają, przeliczy API.',
            apply: 'Zastosuj',
            applyN: 'Zastosuj ({n})',
        },
    },
    entry: {
        cookingServings: 'gotuję {n} porcji',
        fromCooking: 'z gotowania',
        fromPhoto: 'ze zdjęcia',
        typed: 'wpisane',
    },
    today: {
        savedFlash: 'Zapisane: {name}.',
        openRecipeFailed: 'Nie udało się otworzyć przepisu.',
        chatSaved: 'Nowy posiłek: {name} — dodaj go do pory.',
        eatenSubtitle: '{kcal} zjedzone',
        action: 'Co zjadłem',
        prevDay: 'Poprzedni dzień',
        nextDay: 'Następny dzień',
        legacy: {
            title: 'Przenieś swoje posiłki',
            text: 'W starym Jedzeniu masz {n} posiłków i półproduktów — przeniosę je tutaj razem z zestawami i wpisami z ostatnich 90 dni.',
            action: 'Przenieś',
        },
        balance: 'BILANS DNIA',
        fillDayAi: 'Uzupełnij dzień z AI',
        otherSlot: 'Inne',
        addTo: 'Dodaj do: {name}',
        undoEaten: 'Cofnij: {name}',
        markEaten: 'Zjedzone: {name}',
        noSlots: 'Nie masz żadnej pory posiłku — dodaj je w {settings}.',
        noSlotsLink: 'ustawieniach',
        offPlan: 'Zjadłem coś spoza planu',
    },
    counts: {
        meals: '{n} posiłek | {n} posiłki | {n} posiłków',
        semiProducts: '{n} półprodukt | {n} półprodukty | {n} półproduktów',
        sets: '{n} zestaw | {n} zestawy | {n} zestawów',
        entries: '{n} wpis | {n} wpisy | {n} wpisów',
    },
    week: {
        title: 'Tydzień',
        setApplied: '„{name}” wstawiony na {day}.',
        sentToList: 'Na liście „{list}”: {n} pozycja. | Na liście „{list}”: {n} pozycje. | Na liście „{list}”: {n} pozycji.',
        markedBought: 'Oznaczone jako kupione.',
        chatSaved: 'Nowy posiłek: {name} — wybierz go w porze.',
        cost: 'ok. {cost}',
        prevWeek: 'Poprzedni tydzień',
        thisWeek: 'Ten',
        nextWeek: 'Następny tydzień',
        toBasket: 'Do Koszyka',
        showPast: 'Pokaż minione dni ({n})',
        moreFor: 'Więcej: {date}',
        insertSet: 'Wstaw zestaw',
        logEaten: 'Wpisz, co zjedzone',
        cookingShort: 'gotuję {n}',
        eaten: 'zjedzone',
        addSlot: 'Dodaj: {name}, {date}',
    },
    catalogue: {
        title: 'Posiłki',
        mealsCount: '{n} posiłek | {n} posiłki | {n} posiłków',
        setsCount: '{n} zestaw | {n} zestawy | {n} zestawów',
        newMeal: 'Nowy posiłek',
        newSet: 'Nowy zestaw',
        sort: {
            name: 'Nazwa',
            recent: 'Ostatnio jedzone',
            kcal: 'Najlżejsze',
            protein: 'Najwięcej białka',
        },
        changedFlash: 'Zmienione: {name}.',
        newMealFlash: 'Nowy posiłek: {name}.',
        setSaved: 'Zestaw „{name}” zapisany.',
        setDeleted: 'Zestaw usunięty.',
        tabMeals: 'Posiłki',
        tabSets: 'Zestawy dnia',
        searchPlaceholder: 'Szukaj posiłku…',
        search: 'Szukaj posiłku',
        order: 'Kolejność',
        all: 'Wszystkie',
        pricePerServing: 'ok. {price} / porcja',
        servingsFor: 'na {n} porcji',
        choices: 'do wyboru: {list}',
        noIngredients: 'bez składników',
        emptyFiltered: 'Nic tu nie pasuje',
        empty: 'Nie masz jeszcze posiłków',
        emptyFilteredHint: 'Zmień filtr albo szukaną frazę.',
        emptyHint: 'Dodaj pierwszy albo przenieś posiłki ze starego Jedzenia w ustawieniach.',
        setsIntro: 'Gotowe dni, które wstawiasz do Tygodnia jednym ruchem — bez rozpisywania od zera.',
        planSet: 'Ułóż zestaw pod cel',
        setsEmpty: 'Nie masz jeszcze zestawów — „Nowy zestaw" ułoży Ci pierwszy dzień.',
        withAi: 'Z AI',
        withAiHint: 'Opisz, czego chcesz, wklej przepis albo link, zrób zdjęcie dania lub strony z książki.',
        manual: 'Ręcznie',
        manualHint: 'Składniki, porcje i przepis wpisujesz sam.',
    },
    products: {
        title: 'Produkty',
        count: '{n} produkt | {n} produkty | {n} produktów',
        synced: {
            both: 'Uzupełnione szacunkiem: {estimated}, ceny z paragonu: {prices}.',
            estimated: 'Uzupełnione szacunkiem: {estimated}.',
            prices: 'ceny z paragonu: {prices}.',
        },
        filter: {
            all: 'Wszystkie',
            estimate: 'Szacunki AI',
            missing: 'Bez danych',
        },
        scannedNew: 'Nowy produkt: {product} ({variant}).',
        scannedExisting: '{variant} → {product}.',
        badge: {
            missing: 'brak danych',
            label: 'etykieta',
        },
        scan: 'Skanuj opakowanie',
        newPlaceholder: 'Nowy produkt, np. kasza bulgur — resztę uzupełni AI',
        newName: 'Nazwa nowego produktu',
        searchPlaceholder: 'Szukaj produktu albo marki…',
        search: 'Szukaj produktu',
        per100: 'B {protein} · W {carbs} · T {fat} / 100 g',
        packages: '{n} opakowanie | {n} opakowania | {n} opakowań',
        emptyFiltered: 'Nic nie pasuje.',
        empty: 'Zeskanuj pierwsze opakowanie albo dodaj produkt po nazwie.',
        deleted: 'Usunięty: {name}.',
    },
    settings: {
        title: 'Ustawienia',
        subtitle: 'Jedzenie',
        errors: {
            save: 'Nie udało się zapisać pory.',
            add: 'Nie udało się dodać pory.',
            remove: 'Nie udało się usunąć pory.',
            move: 'Nie udało się przenieść danych.',
        },
        slots: {
            title: 'Pory posiłków',
            description: 'Z nich składa się dzień w planie. Godzina jest opcjonalna — ustawia kolejność na osi Planera i domyślną porę szybkiego wpisu.',
            name: 'Nazwa pory {n}',
            time: 'Godzina: {name}',
            up: '{name} wyżej',
            down: '{name} niżej',
            remove: 'Usuń: {name}',
            newPlaceholder: 'Nowa pora, np. Przed treningiem',
            newName: 'Nazwa nowej pory',
            newTime: 'Godzina nowej pory',
            removeTitle: 'Usunąć porę?',
            removeMessage: 'Wpisy z tej pory zostaną w dniu, bez pory.',
        },
        goals: {
            title: 'Cele i preferencje',
            description: 'Jedno miejsce dla całej aplikacji: dzienne cele (kcal, makra, błonnik, cukier, sól) i to, czego nie jesz — z nich korzystają bilans dnia, Planer i propozycje AI.',
            open: 'Otwórz cele i preferencje',
        },
        legacy: {
            title: 'Dane ze starego Jedzenia',
            description: 'Posiłki (półprodukty stają się posiłkami z porcjami, warianty dań — osobnymi posiłkami), zestawy dnia i wpisy z ostatnich 90 dni. Stary moduł zostaje nietknięty, a ponowne przeniesienie dodaje tylko to, co nowe.',
            moved: 'Przeniesione: {meals}, {sets}, {entries}.',
            nothingNew: 'Wszystko już było przeniesione.',
            summary: 'W starym module: {meals}, {semi}, {sets}, {entries}.',
            movedAt: 'Przeniesione {date}.',
            moving: 'Przenoszę…',
            moveNew: 'Przenieś nowe',
            moveMine: 'Przenieś moje dane',
        },
    },
    goals: {
        inPlan: 'w planie',
        change: 'Zmień cele',
        set: 'Ustaw cele',
    },
    setPicker: {
        loadFailed: 'Nie udało się pobrać zestawów.',
        applyFailed: 'Nie udało się wstawić zestawu.',
        title: 'Wstaw zestaw · {day}',
        replace: 'Zastąp plan dnia',
        replaceHint: '(zjedzone zostaje)',
        empty: 'Nie masz jeszcze zestawów. Ułóż pierwszy w zakładce {tab}.',
        emptyTab: 'Posiłki → Zestawy dnia',
    },
    shoppingSheet: {
        loadFailed: 'Nie udało się zebrać składników.',
        sendFailed: 'Nie udało się dodać do Koszyka.',
        otherCategory: 'Inne',
        subtitle: 'Odznacz to, co masz w domu — reszta trafi na listę domyślną.',
        from: 'Od',
        to: 'Do',
        loading: 'Zbieram składniki…',
        alreadySent: 'Pomijam {n} posiłek wysłany wcześniej. | Pomijam {n} posiłki wysłane wcześniej. | Pomijam {n} posiłków wysłanych wcześniej.',
        empty: 'Nic do kupienia w tych dniach — zaplanuj posiłki w Tygodniu albo zmień zakres.',
        mealEmpty: 'Ten posiłek nie ma składników z produktów — nie ma czego dodać.',
        mealSubtitle: 'Składniki „{name}” — odznacz to, co masz w domu.',
        servings: 'Na ile porcji',
        recipeFor: 'przepis na {n} porcję | przepis na {n} porcje | przepis na {n} porcji',
        forWhat: 'do: {what}',
        have: 'mam',
        send: 'Dodaj {n} do Koszyka',
        haveAll: 'Mam wszystko',
    },
    mealPicker: {
        meal: 'Posiłek',
        fromCooking: 'Z GOTOWANIA',
        cooked: 'ugotowane {day} · zostały {left}',
        fitsSlot: 'PASUJE NA {slot}',
        recent: 'OSTATNIO JEDZONE',
        results: 'WYNIKI',
        all: 'WSZYSTKIE',
        perServing: '{kcal} / porcja',
        empty: 'Nie masz jeszcze posiłków. Dodaj je w zakładce Posiłki albo wpisz, co zjadłeś.',
        noMatch: 'Nic nie pasuje do „{query}”.',
        cookMore: 'Gotuję więcej porcji',
        servingsUnit: 'porcji',
        cookHint: 'Pozostałe porcje pojawią się na górze wyboru w kolejnych dniach jako „Z gotowania” — a na zakupy trafi tylko to gotowanie.',
        quick: 'Wpisz, co to było',
    },
    entrySheet: {
        photo: 'Zdjęcie posiłku',
        fromCooking: 'Porcja z gotowania: {day}',
        skipped: 'Zaplanowane, ale zjedzone było coś innego.',
        howMuch: 'Ile zjedzone',
        cooking: 'Gotowanie',
        cookingState: 'porcji · rozplanowane {used}, zostało {left}',
        stopCooking: 'Nie gotuję na zapas',
        cookHint: 'Ugotuj więcej i rozłóż porcje na kolejne dni.',
        startCooking: 'Gotuję {n} porcji',
        fromCookingHint: 'Ta porcja pochodzi z gotowania — zmień je w dniu, w którym gotujesz.',
        day: 'Dzień',
        slot: 'Pora',
        cookMode: 'Tryb gotowania',
        ateSomethingElse: 'Zjadłem coś innego',
        backToPlan: 'Cofnij do planu',
        eaten: 'Zjedzone',
        deleteTitle: 'Usunąć wpis?',
        deleteMessage: 'Zniknie z dnia.',
    },
    mealSheet: {
        loadFailed: 'Nie udało się pobrać posiłku.',
        planned: '„{name}” w planie.',
        planFailed: 'Nie udało się zaplanować.',
        duplicateFailed: 'Nie udało się zduplikować.',
        deleted: 'Posiłek usunięty.',
        usedIn: 'Najpierw usuń go ze składu: {list}.',
        perServing: '{kcal} · {macros} — na porcję',
        plan: 'Zaplanuj',
        cook: 'Gotuj',
        chat: 'Ulepsz z AI',
        analysis: 'Analiza',
        duplicate: 'Duplikuj',
        oneServing: 'JEDNA PORCJA',
        moreValues: 'Więcej wartości',
        servingCost: 'Koszt porcji ok. {price}',
        noIngredients: 'Bez składników — dodaj je w edycji, żeby liczyć wartości i zakupy.',
        default: 'domyślnie',
        unknownGrams: 'nie wiem, ile to gramów — uzupełnij wagę sztuki w edycji',
        usedInList: 'Składnik w: {list}',
        recipe: 'PRZEPIS',
        footer: 'Pasuje na: {slots} · przepis na {n} porcji',
        eatenCount: 'jedzone {n}×',
        deleteTitle: 'Usunąć posiłek?',
        deleteMessage: 'Wpisy w dniach zostaną z jego nazwą, a gotowania i miejsca w zestawach znikną.',
    },
    cookMode: {
        label: 'Tryb gotowania: {name}',
        finish: 'Zakończ',
        timerDone: 'Gotowe!',
        timerOff: 'Wyłącz minutnik',
        or: 'albo: {list}',
        steps: 'KROKI',
        noRecipe: 'Ten posiłek nie ma jeszcze przepisu — dopisz go w edycji posiłku, po jednym kroku w linii.',
        stepDone: 'Krok {n} zrobiony',
        timer: 'Minutnik {time}',
        allDone: 'Gotowe — smacznego! ({n} porcji)',
    },
    mealEditor: {
        defaultChoice: 'dodatek',
        nameRequired: 'Podaj nazwę.',
        pieceWeightRequired: 'Ile waży 1 szt.: {name}?',
        editTitle: 'Edytuj posiłek',
        emoji: 'Emoji',
        name: 'Nazwa',
        namePlaceholder: 'np. Indyk z marchewką',
        servingsLabel: 'Przepis jest na',
        slots: 'Pasuje na',
        ingredients: 'Składniki',
        ingredientsHint: '— na cały przepis',
        mealAsIngredient: 'Posiłek jako składnik',
        amount: 'Ilość: {name}',
        unit: 'Jednostka: {name}',
        makeChoice: 'Zrób z tego składnik do wyboru',
        choiceIngredient: 'Składnik do wyboru',
        remove: 'Usuń {name}',
        pieceWeighs: '1 szt. waży',
        pieceWeight: 'Waga sztuki: {name}',
        choiceLabel: 'do wyboru:',
        choiceName: 'Nazwa wyboru: {name}',
        addOption: '+ opcja',
        addingOption: 'Dodajesz opcję do „{name}”',
        cancelLower: 'anuluj',
        optionPlaceholder: 'Np. kluski, ryż…',
        searchPlaceholder: 'Dodaj składnik — produkt albo posiłek…',
        search: 'Szukaj składnika',
        kindMeal: 'posiłek',
        kindProduct: 'produkt',
        createProduct: '+ Nowy produkt „{name}” — wartości oszacuje AI',
        recipe: 'Przepis',
        recipeHint: "— jeden krok w linii; „20 min” da minutnik w trybie gotowania, a {'${'} albo {'@@'} wstawia składnik z ilością",
        insertIngredient: 'Wstaw składnik:',
        insertTimer: 'Minutnik:',
        recipePlaceholder: 'Pokrój indyka w kostkę.\nPodsmaż na oliwie 8 min.\nDodaj marchewkę i duś 20 min.',
    },
    chat: {
        loading: 'Wczytuję rozmowę…',
        readingPhoto: 'Oglądam zdjęcie…',
        readingLink: 'Czytam przepis ze strony…',
        thinking: 'Myślę…',
        sendFailed: 'Nie udało się wysłać.',
        savingMeal: 'Zapisuję posiłek…',
        noMic: 'Brak dostępu do mikrofonu.',
        transcribing: 'Rozpoznaję mowę…',
        transcribeFailed: 'Nie udało się rozpoznać mowy.',
        titleAbout: 'Rozmowa: {name}',
        titleNew: 'Nowy posiłek z AI',
        subtitleNew: 'AI bierze pod uwagę Twoje cele, preferencje i produkty.',
        introNew: 'Opisz, czego chcesz, wybierz akcję poniżej, wklej przepis albo link lub zrób zdjęcie dania czy strony z książki. Dostaniesz kartę posiłku — dopracuj ją dalej, a zapisz, gdy będzie pasować.',
        photo: 'zdjęcie',
        perServing: 'na porcję, przepis na {n}',
        newBadge: 'nowy',
        hideRecipe: 'Schowaj przepis',
        showRecipe: 'Pokaż przepis',
        saved: 'Zapisane',
        apply: 'Zastosuj do „{name}”',
        saveAsNew: 'Zapisz jako nowy',
        saveAsMeal: 'Zapisz jako posiłek',
        chosenPhoto: 'Wybrane zdjęcie',
        removePhoto: 'Usuń zdjęcie',
        addPhoto: 'Dodaj zdjęcie',
        stopRecording: 'Zakończ nagrywanie',
        record: 'Nagraj',
        placeholderAbout: 'Np. zrób wersję bez glutenu',
        placeholderNew: 'Opisz posiłek, wklej przepis albo link',
        sendHint: 'Wyślij (Ctrl+Enter)',
        assistantHint: 'Proś o zmiany — zobaczysz je, zanim cokolwiek zastosujesz.',
        introAbout: 'Powiedz, co zmienić, albo wybierz akcję poniżej. Dostaniesz propozycję z listą zmian — posiłek zmieni się dopiero, gdy klikniesz „Zastosuj zmiany”.',
        kept: 'Rozmowa zostaje przy posiłku — możesz do niej wrócić.',
        backToMeal: 'Posiłek',
        hideAssistant: 'Schowaj',
        proposal: 'PROPOZYCJA',
        applyChanges: 'Zastosuj zmiany',
        showAll: 'Pokaż cały skład',
        hideAll: 'Schowaj skład',
        diff: {
            heading: 'PROPONOWANE ZMIANY',
            headingPrevious: 'ZMIANY WZGLĘDEM POPRZEDNIEJ PROPOZYCJI',
            perServing: 'na porcję',
            sameValues: 'Wartości na porcję bez zmian.',
            protein: 'B',
            carbs: 'W',
            fat: 'T',
            name: 'Nowa nazwa: {name}',
            servings: 'Porcje: {from} → {to}',
            recipe: 'Zmieniony przepis',
        },
        start: {
            quickDinner: 'Szybki obiad',
            quickDinnerText: 'Szybki obiad do 30 minut, ok. 600 kcal',
            proteinBreakfast: 'Białkowe śniadanie',
            proteinBreakfastText: 'Śniadanie z dużą ilością białka',
            lightSupper: 'Lekka kolacja',
            lightSupperText: 'Lekka kolacja do 400 kcal',
            fromMine: 'Z moich produktów',
            fromMineText: 'Zaproponuj posiłek głównie z produktów, które mam w katalogu.',
            goals: 'Pod moje cele',
            goalsText: 'Zaproponuj posiłek, który dobrze pasuje do moich dziennych celów.',
            photo: 'Zdjęcie dania lub przepisu',
            paste: 'Wklej przepis lub link',
        },
        actions: {
            label: 'Szybkie akcje',
            fewerCalories: 'Mniej kalorii',
            fewerCaloriesText: 'Zmniejsz kalorie o ok. 20%, zachowując smak i sytość.',
            moreProtein: 'Więcej białka',
            moreProteinText: 'Zwiększ ilość białka, nie podnosząc dużo kalorii.',
            goals: 'Dopasuj do celów',
            goalsText: 'Dopasuj ten posiłek do moich dziennych celów.',
            swap: 'Zamień składnik',
            swapText: 'Zamień ',
            servings: 'Zmień porcje',
            servingsText: 'Przelicz przepis na ',
            vegetarian: 'Wersja wege',
            vegetarianText: 'Zrób wersję wegetariańską.',
            quicker: 'Szybciej',
            quickerText: 'Uprość przepis, żeby był gotowy szybciej.',
        },
        message: 'Wiadomość',
        send: 'Wyślij',
    },
    planAi: {
        working: 'Układam…',
        nameFromNote: 'Dzień: {note}',
        defaultName: 'Dzień pod cel',
        failed: 'Nie udało się ułożyć dnia.',
        addedToPlan: 'Dodane do planu: {n}.',
        state: {
            ok: 'w celu',
            under: 'za mało',
            over: 'za dużo',
        },
        dayTitle: 'Uzupełnij dzień · {day}',
        daySubtitle: 'AI wypełni puste pory Twoimi posiłkami, najpierw porcjami z gotowań.',
        setSubtitle: 'AI złoży dzień z Twoich posiłków tak, żeby trafić w cele.',
        dayPlaceholder: 'Życzenia (opcjonalnie), np. lekka kolacja',
        setPlaceholder: 'Np. dzień treningowy, bez nabiału',
        wishes: 'Życzenia',
        again: 'Jeszcze raz',
        propose: 'Ułóż',
        emptyDay: 'Nie ma tu nic do uzupełnienia albo brakuje pasujących posiłków.',
        emptySet: 'Brakuje posiłków, z których dało się ułożyć dzień.',
        wholeDay: 'Cały dzień: {kcal} · {macros}',
        missing: 'Przydałby się jeszcze: {meal}',
        askRecipe: 'Poproś AI o przepis',
        setName: 'Nazwa zestawu',
        addToPlan: 'Dodaj do planu ({n})',
        saveSet: 'Zapisz zestaw',
    },
    productSheet: {
        loadFailed: 'Nie udało się pobrać produktu.',
        priceRequired: 'Podaj cenę za kilogram.',
        removeVariantFailed: 'Nie udało się usunąć wariantu.',
        usedIn: 'Jest w posiłkach: {list} — najpierw usuń go z ich składu.',
        product: 'Produkt',
        lastBrand: 'ostatnio: {brand}',
        per100: 'NA 100 G',
        restoreValues: 'Przywróć automatyczne',
        correct: 'Popraw',
        valuesHint: 'Kalorie policzą się z białka, węglowodanów i tłuszczu. Twoja poprawka wygrywa z etykietą i szacunkiem.',
        price: 'CENA',
        restorePrice: 'Przywróć automatyczną',
        priceEarlier: 'wpisana wcześniej',
        priceUnknown: 'Jeszcze nie wiem — pojawi się z paragonu, zakupów w Koszyku albo szacunku.',
        perKg: 'Za kilogram ({currency})',
        inShop: 'W SKLEPIE',
        scan: 'Zeskanuj opakowanie',
        noVariants: 'Zeskanuj kod z opakowania — marka, wartości z etykiety i wielkość opakowania wpiszą się same.',
        labelCorrected: 'etykieta poprawiona',
        label: 'etykieta',
        noLabel: 'bez etykiety',
        removeVariant: 'Usuń wariant {name}',
        details: 'SZCZEGÓŁY',
        change: 'Zmień',
        noCategoryLower: 'bez kategorii',
        inMeals: 'W posiłkach: {list}',
        name: 'Nazwa (ogólna, bez marki)',
        category: 'Kategoria sklepowa',
        noCategory: 'Bez kategorii',
        pieceWeight: 'Waga 1 sztuki (g)',
        pieceName: 'Sztuka to',
        pieceNamePlaceholder: 'np. jajko',
        density: 'Gęstość (g/ml)',
        delete: 'Usuń produkt',
        deleteTitle: 'Usunąć produkt?',
        deleteMessage: 'Zniknie z katalogu razem z wariantami.',
    },
    scan: {
        unknownCode: 'Nie znam tego kodu — zrób zdjęcie etykiety z wartościami odżywczymi.',
        unreadable: 'Nie udało się odczytać etykiety — spróbuj z bliska, z tabelą wartości.',
        aiUnavailable: 'AI jest teraz niedostępne — wskaż produkt i spróbuj później.',
        title: 'Opakowanie',
        checking: 'Sprawdzam opakowanie…',
        takePhoto: 'Zrób zdjęcie etykiety',
        again: 'Skanuj kod jeszcze raz',
    },
    quick: {
        recognising: 'Rozpoznaję…',
        notRecognised: 'Nie rozpoznałem jedzenia — napisz np. „jajecznica z 3 jajek i kromka chleba”.',
        recogniseFailed: 'Nie udało się rozpoznać.',
        noSound: 'Nic nie słyszę — sprawdź mikrofon.',
        noSpeech: 'Nie rozpoznano mowy — spróbuj jeszcze raz.',
        dictationUnavailable: 'Dyktowanie jest teraz niedostępne.',
        recordingFailed: 'Nie udało się wysłać nagrania.',
        titleInstead: 'Co zjadłeś zamiast?',
        title: 'Co zjadłeś?',
        instead: 'Zamiast: {name}',
        subtitle: 'Powiedz albo wpisz — zobaczysz podgląd przed zapisem.',
        platePhoto: 'Zdjęcie talerza',
        addNote: 'Dopisz, jeśli coś nie widać (opcjonalnie)',
        orType: 'Albo wpisz',
        placeholder: 'np. kawa z mlekiem i drożdżówka',
        fromCatalogue: 'Z Twojego katalogu',
        fromCatalogueShort: 'z katalogu',
        total: 'Razem {kcal}',
        editDescription: 'Popraw opis',
        recognise: 'Rozpoznaj',
        saveEaten: 'Zapisz jako zjedzone',
    },
    setEditor: {
        nameRequired: 'Podaj nazwę zestawu.',
        saveFailed: 'Nie udało się zapisać zestawu.',
        title: 'Zestaw dnia',
        newTitle: 'Nowy zestaw dnia',
        ofGoal: '{kcal} z {goal}',
        namePlaceholder: 'np. Dzień treningowy',
        add: '+ Dodaj',
        removeItem: 'Usuń z zestawu',
        deleteTitle: 'Usunąć zestaw?',
        deleteMessage: 'Wpisy wstawione z niego zostają.',
    },
    analysis: {
        goals: {
            health: { label: 'Zdrowie ogólnie', hint: 'błonnik, białko, mniej tłuszczów nasyconych' },
            active: { label: 'Dla aktywnych', hint: 'białko i energia wokół treningu' },
            cut: { label: 'Redukcja', hint: 'mniej kalorii, ta sama sytość' },
            lessSugarSalt: { label: 'Mniej cukru i soli', hint: 'bez utraty smaku' },
        },
        goalRequired: 'Wybierz cel albo opisz, czego chcesz.',
        errors: {
            noIngredients: 'Posiłek nie ma składników do analizy.',
            aiError: 'Błąd usługi AI — spróbuj ponownie.',
            notConfigured: 'Usługa AI nie jest skonfigurowana.',
            generic: 'Nie udało się przeanalizować posiłku.',
            conflict: 'Tej zmiany nie da się już zastosować — składnik zmienił się w międzyczasie.',
            apply: 'Nie udało się zastosować zmiany.',
        },
        type: {
            changeAmount: 'Zmień ilość',
            replace: 'Zamień',
            add: 'Dodaj',
            remove: 'Usuń',
        },
        delta: {
            protein: 'B',
            carbs: 'W',
            fat: 'T',
            sugar: 'cukry',
            fiber: 'błonnik',
            salt: 'sól',
        },
        before: {
            protein: 'białko',
            carbs: 'węgle',
            fat: 'tłuszcz',
        },
        badge: 'ANALIZA AI',
        angle: 'Pod jakim kątem?',
        note: 'Własne życzenia',
        noteHint: '— opcjonalnie, albo zamiast celu',
        notePlaceholder: 'np. bez nabiału, więcej warzyw, ma być gotowe w 15 minut',
        backToResult: 'Wróć do analizy',
        running: 'Analizuję…',
        run: 'Analizuj',
        beforeTitle: 'PORCJA PRZED ZMIANAMI',
        noSuggestions: 'AI nie ma propozycji zmian — posiłek pasuje do celu.',
        newProduct: 'nowy produkt',
        apply: 'Zastosuj',
        applied: 'Zastosowano',
        estimateNote: 'Zmiany makr są szacunkowe, dla jednej porcji.',
        new: 'Nowa analiza',
    },
    picker: {
        placeholder: 'Zacznij pisać nazwę',
        semi: 'półprodukt · {kcal} kcal / {portion}',
        free: 'Brak w katalogu — dodam jako „{name}" bez makr.',
        none: 'Nie ma takiego produktu w katalogu.',
    },
    recipeEditor: {
        bold: 'Pogrubienie',
        italic: 'Kursywa',
        numbered: 'Lista numerowana — numer robi z linii krok do odhaczenia',
        insertRef: 'Wstaw odwołanie do składnika: {name}',
        placeholder: "1. Wsyp ${'{'}płatki{'}'} do garnka…",
        hint: 'Numer na początku linii robi z niej krok do odhaczenia. Składnik wstawisz przez {dollar} albo {at} — obie formy działają tak samo.',
        save: 'Zapisz przepis',
    },
    recipeImport: {
        errors: {
            invalid: 'Wklej podsumowanie przepisu (najwyżej 20 000 znaków).',
            analyze: 'Nie udało się przeanalizować przepisu.',
        },
        mode: {
            new: 'Nowy półprodukt',
            existing: 'Istniejący półprodukt',
            flatten: 'Nie rób półproduktu — składniki do posiłku',
        },
        title: 'Import przepisu',
        pasteSubtitle: 'Wklej gotowe podsumowanie: składniki z gramaturą i kroki przygotowania.',
        reviewSubtitle: 'Sprawdź dopasowania przed zapisem — nic jeszcze nie jest zapisane.',
        summary: 'Podsumowanie przepisu',
        summaryPlaceholder: 'Makaron z pesto (1 porcja)\n- 100 g makaronu penne\n- …\n\n1. Ugotuj makaron…',
        mealName: 'Nazwa posiłku',
        category: 'Kategoria',
        duplicate: 'Posiłek „{name}" już istnieje — zapis utworzy drugi. Zmień nazwę, jeśli to inny wariant.',
        servingsSplit: 'Przepis był na {n} porcje — ilości podzielono na jedną porcję.',
        ingredientsOne: 'Składniki (1 porcja)',
        addedManually: 'dodany ręcznie',
        grams: 'Gramy: {name}',
        removeIngredient: 'Usuń składnik',
        or: 'lub:',
        pickOr: 'Wybierz produkt z katalogu albo',
        createNew: 'utwórz nowy „{name}"',
        addIngredient: 'Dodaj składnik',
        skipped: 'Pominięte (bez ilości):',
        addWithWeight: 'Dodaj z wagą',
        semi: 'Półprodukt: {name}',
        mealPortions: 'Porcji w posiłku',
        whichSemi: 'Który półprodukt',
        pickSemi: 'Wybierz półprodukt',
        portions: 'Porcji',
        portionName: 'Nazwa porcji',
        flattenHint: 'Składniki trafią wprost do posiłku, przeliczone na jego porcję ({used} z {total} porcji półproduktu).',
        ingredientsSemi: 'Składniki (cały półprodukt)',
        inMeal: 'w posiłku: {g} g',
        semiRecipe: 'Przepis półproduktu',
        newProducts: 'Nowe produkty ({n})',
        newProductsHint: 'Wartości na 100 g oszacowało AI; sól w mg, cena w {currency}/kg.',
        productName: 'Nazwa produktu {name}',
        collapse: 'Zwiń',
        macros: 'Makra',
        requirements: 'Do zapisu potrzebna jest nazwa, a każdy składnik musi mieć produkt i gramy (półprodukt: nazwę lub wybór z listy).',
        backToText: 'Wróć do tekstu',
        analyze: 'Przeanalizuj',
        save: 'Zapisz posiłek',
    },
    firstSteps: {
        goals: {
            title: 'Cel żywieniowy',
            action: 'Ustaw cele',
            what: 'Ustaw dzienne kalorie, a jeśli chcesz, także białko i resztę — albo kliknij „Wylicz za mnie".',
            why: 'Bilans dnia pokaże, ile brakuje do celu, a AI będzie układać dni pod te liczby.',
        },
        preferences: {
            title: 'Preferencje żywieniowe',
            action: 'Uzupełnij',
            what: 'Alergie, czego nie jesz, co lubisz, sprzęt w kuchni i ile zwykle masz czasu na gotowanie.',
            why: 'Każda propozycja AI w Jedzeniu — posiłki, zestawy, uzupełnianie dnia — weźmie je pod uwagę.',
        },
        meal: {
            title: 'Pierwszy posiłek',
            action: 'Dodaj posiłek',
            what: 'Posiłek to jedna porcja dania ze składnikami. Opisz go AI, wklej przepis albo wpisz składniki sam.',
            why: 'Z posiłków planujesz dni — wartości i koszt porcji policzą się same ze składników.',
        },
        product: {
            title: 'Produkt',
            action: 'Dodaj produkt',
            what: 'Produkt to składnik ogólny, np. „mleko 2%". Wystarczy nazwa albo zeskanowane opakowanie.',
            why: 'Wartości na 100 g i ceny produktów liczą posiłki. Uzupełniają się same z etykiet, paragonów i Koszyka.',
        },
        plan: {
            title: 'Zaplanuj posiłek',
            action: 'Zaplanuj',
            what: 'Wstaw posiłek w porę dnia — na dziś albo na kolejne dni tygodnia.',
            why: 'Zaplanowane widać w bilansie jako „w planie", a z planu tygodnia zrobisz listę zakupów.',
        },
        eaten: {
            title: 'Zjedzone',
            action: 'Zapisz, co zjadłeś',
            what: 'Odhacz zaplanowany posiłek albo powiedz czy wpisz, co zjadłeś spoza planu — także ze zdjęcia.',
            why: 'Bilans dnia liczy się tylko z tego, co zjedzone.',
        },
        cooking: {
            title: 'Gotowanie na kilka porcji',
            action: 'Zaplanuj gotowanie',
            what: 'Przy planowaniu posiłku zaznacz „Gotuję więcej porcji" i wybierz, ile ich będzie.',
            why: 'Pozostałe porcje czekają na górze wyboru w kolejnych dniach, a na zakupy trafia tylko jedno gotowanie.',
        },
        set: {
            title: 'Zestaw dnia',
            action: 'Utwórz zestaw',
            what: 'Gotowy układ posiłków na cały dzień, np. „Dzień roboczy". Złożysz go sam albo z AI.',
            why: 'Wstawiasz go do planu jednym ruchem zamiast rozpisywać dzień od zera.',
        },
    },
    help: {
        slots: {
            title: 'Pory dnia',
            text: 'Plan dnia ułożony w pory posiłków. Kółkiem odhaczasz to, co zjedzone; „+" dodaje posiłek do pory.',
            more: 'Wieczorem niezjedzone z planu szarzeją — bez kar i przypomnień. Wpis otwiera szczegóły: porcje, zamiana na coś innego, tryb gotowania. Pory ustawisz w Ustawieniach.',
        },
        balance: {
            title: 'Bilans dnia',
            text: 'Ile zjadłeś względem celów żywieniowych: kalorie, makro i reszta. Liczy się tylko to, co zjedzone; zaplanowane widać obok.',
            more: 'Cele ustawiasz raz, w Ustawieniach → Cele i preferencje — są wspólne dla całej aplikacji. Bez celów bilans pokazuje same sumy.',
        },
        quick: {
            title: 'Szybki wpis',
            text: 'Zjadłeś coś spoza planu? Powiedz, wpisz albo zrób zdjęcie. AI dopasuje to do Twoich posiłków i produktów, a przed zapisem zobaczysz podgląd.',
        },
        week: {
            title: 'Tydzień',
            text: 'Dni tygodnia z porami. Puste pory to małe przyciski — tapnij, żeby wybrać posiłek. W menu „…" przy dniu wstawisz zestaw dnia albo uzupełnisz dzień z AI.',
            more: 'Liczba przy dniu to zaplanowane kalorie, a po ukośniku Twój cel — liczba robi się czerwona, gdy przekracza go o ponad 10%. Ugotowane porcje rozplanujesz na kolejne dni, a „Do Koszyka" zbierze składniki planu na listę zakupów.',
        },
        basket: {
            title: 'Do Koszyka',
            text: 'Składniki zaplanowanych posiłków trafiają na listę domyślną w Koszyku. Przed wysłaniem odznaczysz to, co masz w domu.',
        },
        meals: {
            title: 'Posiłki',
            text: 'Twoje posiłki — każdy to jedna porcja dania ze składnikami, z kaloriami, makro i kosztem porcji. Filtr po porach pokazuje, co pasuje na śniadanie, a co na obiad.',
            more: 'Nowy posiłek opiszesz AI (także z linku, tekstu albo zdjęcia przepisu) albo wpiszesz sam. Z karty posiłku zaplanujesz go, ugotujesz w trybie gotowania albo poprosisz AI o analizę.',
        },
        sets: {
            title: 'Zestawy dnia',
            text: 'Gotowe układy posiłków na cały dzień. W Tygodniu wstawiasz zestaw do dnia jednym ruchem.',
            more: 'AI może złożyć zestaw z Twoich posiłków tak, żeby trafić w cele. Przy zestawie widać jego kalorie względem celu.',
        },
        products: {
            title: 'Produkty',
            text: 'Składniki ogólne, np. „mleko 2%", z wartościami na 100 g i ceną. Nowy produkt dodasz samą nazwą — resztę oszacuje AI.',
            more: 'Wartości i ceny uzupełniają się same: z etykiet zeskanowanych opakowań, paragonów i zakupów w Koszyku. Zaglądasz tu głównie, żeby poprawić błąd. Katalog produktów jest wspólny z Koszykiem.',
        },
        scan: {
            title: 'Skanowanie opakowania',
            text: 'Zdjęcie kodu kreskowego i etykiety dopisze towar do produktu razem z wartościami z etykiety — dokładniejszymi niż szacunek AI.',
        },
        slotSettings: {
            title: 'Pory posiłków',
            text: 'Nazwane części dnia z godziną, np. Śniadanie o 8:00. Z nich składa się plan każdego dnia; godzina podpowiada porę przy szybkim wpisie.',
        },
        goals: {
            title: 'Cele i preferencje',
            text: 'Dzienne cele żywieniowe i preferencje (alergie, czego nie jesz, sprzęt) ustawiasz w jednym miejscu dla całej aplikacji.',
            more: 'Cele widać w bilansie dnia i w Tygodniu, a preferencje bierze pod uwagę każda propozycja AI w Jedzeniu.',
        },
        legacy: {
            title: 'Dane ze starego Jedzenia',
            text: 'Przenosi posiłki, zestawy i wpisy ze starego modułu. Stary moduł zostaje nietknięty, a powtórne przeniesienie dodaje tylko nowe rzeczy.',
        },
    },
    tour: {
        welcome: {
            title: 'Witaj w Jedzeniu',
            description: 'Planujesz posiłki na dni tygodnia, odhaczasz zjedzone i widzisz bilans względem swoich celów. Zakupy z planu trafiają prosto do Koszyka.',
        },
        end: {
            title: 'To wszystko',
            description: 'Przewodnik wróci zawsze pod przyciskiem „Pomoc" — tam są też Pierwsze kroki. A „Co to?" przy sekcji wyjaśnia ją bez przewodnika.',
        },
    },
};
